
import { PropType, defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import ConfirmationOverlay from '@/components/ConfirmationOverlay.vue';
import { ActionTypes } from '@/store/actionTypes';
import {
    TrailerAssessmentQuestion,
    TrailerAssessmentAnswer,
} from '@/types/TrailerAssessmentQuestion';
import ConfirmationDamageList from '@/components/ConfirmationDamageList.vue';
import { isNullOrUndefined } from '@/shared/helpers';
import LastTrailerAssessmentResult from '@/types/LastTrailerAssessmentResult';
import { AssociationType } from '@/types/AssociationType';

export default defineComponent({
    props: {
        showConfirmation: {
            type: Boolean,
            default: false,
        },
        submitting: {
            type: Boolean,
            default: false,
        },
        trailerAssessmentResult: {
            type: LastTrailerAssessmentResult || null,
            default: null,
            required: false,
        },
        association: {
            type: String as PropType<AssociationType>,
            default: AssociationType.ATTACH,
        },
    },
    components: {
        ConfirmationOverlay,
        ConfirmationDamageList,
    },
    computed: {
        ...mapGetters({
            selectedTrailer: 'selectedTrailer',
        }),
        isAssessmentForPreviousTrailer() {
            return (
                !isNullOrUndefined(this.trailerNumber) &&
                !isNullOrUndefined(this.selectedTrailer) &&
                this.trailerNumber !== this.selectedTrailer.trailerNumber
            );
        },
        isAssessmentTrailerDotExpired() {
            return (
                this.isAssessmentForPreviousTrailer === false &&
                this.selectedTrailer?.isDotInspectionExpired === true
            );
        },
        trailerNumber() {
            return this.$route.params.trailerNumber as string;
        },
    },
    methods: {
        showBreakdownConfirmation(): void {
            this.$router.push({
                query: {
                    ...this.$route.query,
                    confirmation: 'acceptwithdamage',
                },
            });
        },
        acceptPrompt(): void {
            this.updateAssessmentResponse(true);
            this.showBreakdownConfirmation();
            this.$emit('accepted', { didAccept: true });
        },
        rejectPrompt(): void {
            this.updateAssessmentResponse(false);
            this.showBreakdownConfirmation();
            this.$emit('accepted', { didAccept: false });
        },
        updateAssessmentResponse(isSafe: boolean): void {
            this.$store.dispatch(
                ActionTypes.UPDATE_TRAILER_ASSESSMENT_QUESTION,
                {
                    question: TrailerAssessmentQuestion.DOT_SAFE,
                    answer: isSafe
                        ? TrailerAssessmentAnswer.YES
                        : TrailerAssessmentAnswer.NO,
                }
            );
        },
    },
});
